import Select from "react-select";

const SelectField = ({
  label,
  name,
  value,
  options,
  compulsory = false,
  formField = true,
  error,
  ...props
}) => (
  <div className={`form-group ${formField ? "mt-3" : ""}`}>
    {formField && (
      <label className="label" htmlFor={name}>
        {label}
      </label>
    )}
    <div className={`flex ${props.isDisabled ? "" : "pb-3"}`}>
      <Select
        className={`${
          formField ? "myreact-select-2 container-select" : "myreact-select"
        }`}
        inputId={name}
        name={name}
        value={value}
        options={options}
        {...props}
      ></Select>
      {compulsory && <span className="label-imp-select-prd">*</span>}
    </div>{" "}
    {error && formField ? (
      <p className="label-error">{error}</p>
    ) : (
      error && <p className="label-error-pos">{error}</p>
    )}
  </div>
);

export default SelectField;
